import { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { STORAGE_KEY } from '../const';
import OrderService from '../services/OrderService';
import { ShopContext } from './ShopContext';

export const OrderContext = createContext();

export function OrderProvider(props) {
  const { shop } = useContext(ShopContext);

  const [orders, setOrders] = useState([]);
  const [ordersCount, setOrdersCount] = useState(0);

  const countOrders = useCallback(() => {
    const orders = JSON.parse(localStorage.getItem(`${shop?.shopId}-${STORAGE_KEY.ORDERS}`) || '[]');
    setOrdersCount(orders.length);
  }, [shop?.shopId]);

  const getOrder = async (sale) => {
    const res = await OrderService.getOrder(sale, shop?.shopId);
    setOrders([...orders, res.data]);
  };

  useEffect(() => {
    setOrders([]);
    setOrdersCount(0);
    countOrders();
  }, [shop?.shopId, countOrders]);

  return (
    <OrderContext.Provider
      value={{
        orders,
        setOrders,
        countOrders,
        getOrder,
        ordersCount,
      }}
    >
      {props.children}
    </OrderContext.Provider>
  );
}
